module.exports = __webpack_public_path__ + "static/media/loading-img.0c8251c8.png";